import { render, staticRenderFns } from "./localHotList.vue?vue&type=template&id=1f3775c0&"
import script from "./localHotList.vue?vue&type=script&lang=js&"
export * from "./localHotList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports